import { all_routes } from '../../feature-module/router/all_routes';

type RoleType = "ADMIN" | "MANAGER" | "VERIFIER";

const roleRouteMap: Record<RoleType, string> = {
    ADMIN: all_routes.admin_hrActionRequired,
    MANAGER: all_routes.manager_HRActionRequired,
    VERIFIER: all_routes.verifier_liveCaseProgress,
};

const isRoleType = (value: string): value is RoleType => {
    return value in roleRouteMap;
};

const getDynamicRedirect = (role?: string) => {
    if (!role) return all_routes.login;
    const upperRole = role.toUpperCase();
    return isRoleType(upperRole) ? roleRouteMap[upperRole] : all_routes.login;
}
export default getDynamicRedirect
